
import { IGlobalState } from "@/store";
import HEADER_MENU from "@/typings/app";
import { IApplication } from "@/typings/application";
import { IDocGroup } from "@/typings/doc";
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  PropType,
  onUpdated,
} from "vue";
import { useRouter, onBeforeRouteUpdate } from "vue-router";
import { useStore } from "vuex";
interface Imenu {
  id: string;
  name: string;
  path: string;
}

export default defineComponent({
  props: {
    menuList: {
      type: [Array] as PropType<Imenu[]>,
      default: () => [],
    },
  },
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      // curMenu: props.menuList[0],
      curMenuId:props.menuList[0].id
    });
    // 头部当前选中的菜单下标
    const headerMenuIndex = computed({
      get: () => store.state.app.headerMenuIndex,
      set: (val) => {
        store.state.app.headerMenuIndex = val;
      },
    });
    /**
     * 改变当前选中菜单
     */
    function changeCurMenu(menu: Imenu) {
      state.curMenuId = menu.id;
      router.push({ path: menu.path, query: router.currentRoute.value.query });
    }
    /**
     * 接口分组菜单选中时跳转到接口列表列
     */
    function openGroupApi(menu: IDocGroup) {
       state.curMenuId = menu.id;
      if (!menu.path) {
        router.push({
          name: "interfacelist",
          query: router.currentRoute.value.query,
          params: { groupid: menu.id, groupname: menu.title },
        });
      } else {
        router.push({
          path: menu.path,
        });
      }
    }
    /**
     * 页面一开始加载就进入第一个菜单页面
     */
    onMounted(() => {
      router.push({
        path: props.menuList[0].path,
        query: router.currentRoute.value.query,
      });
      headerMenuIndex.value = HEADER_MENU.API;
    });
    return {
      ...toRefs(state),
      props,
      changeCurMenu,
      openGroupApi,
    };
  },
});
